import { combineReducers, configureStore } from '@reduxjs/toolkit';

import authReducer from '@common/components/authentication/auth.slice';
import themeReducer from '@common/theme/theme.slice';
import multiAccountReducer from '@common/components/authentication/multi-account.slice';
import initializationReducer from '@common/components/authentication/initialization.slice';
import orgReducer from './org.slice';

import { AgentsApi } from '../apis/agents.api';
import { TestApi } from '../apis/test.api';
import { GenerateApi } from '../apis/generate.api';

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  multiAccount: multiAccountReducer,
  initialization: initializationReducer,
  org: orgReducer,
  [AgentsApi.reducerPath]: AgentsApi.reducer,
  [TestApi.reducerPath]: TestApi.reducer,
  [GenerateApi.reducerPath]: GenerateApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (gDM) =>
    gDM().concat(AgentsApi.middleware).concat(TestApi.middleware).concat(GenerateApi.middleware),
});
